import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import FeedbackButton from '@/components/FeedbackButton';
import SccPressable from '@/components/SccPressable';
import { usePlaceDetailScreenName } from '@/hooks/useFeatureFlags';
import useNavigation from '@/navigation/useNavigation';
import { Text, View } from 'react-native';
export default function UpvotedPlaceItem({ item }) {
    const navigation = useNavigation();
    const pdpScreen = usePlaceDetailScreenName();
    const targetType = item.accessibilityType;
    const targetId = item.accessibilityId;
    return (_jsxs(View, { className: "gap-4", children: [_jsxs(SccPressable, { className: "gap-1", elementName: "navigate_to_place_detail_button", onPress: () => navigation.navigate(pdpScreen, {
                    placeInfo: {
                        placeId: item.id,
                    },
                }), children: [_jsx(Text, { className: "text-[16px] font-pretendard-bold leading-[24px] text-gray-90", children: item.name }), _jsx(Text, { className: "text-[13px] font-pretendard-regular leading-[18px] text-gray-50", children: item.address })] }), _jsx(FeedbackButton, { total: item.totalUpvoteCount, isUpvoted: item.isUpvoted, onPressAnalytics: () => {
                    navigation.navigate('UpvoteAnalytics', {
                        targetType,
                        targetId,
                    });
                } })] }));
}
